import { ToolSet } from "ai";

import { McpToolSet } from "../types";

type ToolCallParams = {
  toolCallId: string;
  toolName: string;
  input: unknown;
};

type AddToolOutputFn = (params: { toolCallId: string; tool: string; output: unknown }) => void;

type ExecuteToolCallParams = {
  mcpTools: McpToolSet;
  frontendTools: ToolSet;
  toolCall: ToolCallParams;
  addToolOutput: AddToolOutputFn;
  abortSignal?: AbortSignal;
};

const extractMcpOutput = (result: unknown): unknown => {
  if (
    typeof result === "object" &&
    result !== null &&
    "content" in result &&
    Array.isArray((result as { content: unknown[] }).content)
  ) {
    const mcpResult = result as {
      content: Array<{ type: string; text?: string }>;
      isError?: boolean;
    };
    const textParts = mcpResult.content
      .filter((c) => c.type === "text" && c.text)
      .map((c) => c.text)
      .join("\n");
    return textParts || result;
  }
  return result;
};

export const executeToolCall = async ({
  mcpTools,
  frontendTools,
  toolCall,
  addToolOutput,
  abortSignal,
}: ExecuteToolCallParams): Promise<void> => {
  const { toolCallId, toolName, input } = toolCall;

  const frontendTool = frontendTools[toolName];
  if (frontendTool?.execute) {
    const result = await frontendTool.execute(input, {
      toolCallId,
      messages: [],
      abortSignal,
      context: undefined,
    });
    addToolOutput({ toolCallId, tool: toolName, output: result });
    return;
  }

  const mcpTool = mcpTools[toolName];
  if (!mcpTool?.execute) {
    addToolOutput({ toolCallId, tool: toolName, output: `Tool not found: ${toolName}` });
    return;
  }

  const result = await mcpTool.execute(input, {
    toolCallId,
    messages: [],
    abortSignal,
    context: undefined,
  });
  addToolOutput({ toolCallId, tool: toolName, output: extractMcpOutput(result) });
};
